import React, { useState, useRef } from "react";
import "../../styles/uploadPhotoTimelineStyle.css";
// import CloseIcon from "@mui/icons-material/Close";
import PostPhotoItem from "../components/PostPhotoItem";
import closebutton from "src/Assets/images/CloseButton.svg";
import Api from "src/network";
import Add from "src/Assets/images/Add.svg";
import "./index.css";
import { compressFile } from "src/Utils/imageCompressionUtil";

export default function UploadPhotoTimeLineDialog({
  tenantId,
  zIndex,
  showDialog,
  onCancelDialog,
  onUploadSuccess,
}) {
  let [photosList, setPhotosList] = useState([]);
  const [isLocationSelect, setIsLocationSelect] = useState("");
  const [isLat, setLat] = useState("");
  const [isLng, setLng] = useState("");
  const [open, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [activePhotoId, setActivePhotoId] = useState(null);

  const removeImageClick = (id) => {
    if (isUploading) return;
    const list = photosList.filter((item) => item.id !== id);
    // Update the state with the new array
    setPhotosList(list);
    console.log("Id: " + id);
  };

  const onDescriptionChange = (e, id) => {
    if (isUploading) return;
    const list = photosList.map((item) =>
      item.id === id ? { ...item, description: e.target.value } : item
    );
    // Update the state with the new list
    setPhotosList(list);
  };

  const onPostClick = async (event) => {
    if (event) event.preventDefault();
    if (isUploading || photosList.length === 0) return;

    setIsUploading(true);

    try {
      // Sequential upload preserves exact order of photos (with and without location)
      for (let item of photosList) {
        const formData = new FormData();
        const coords = item.coordinates?.trim();
        formData.append("tmlPhotoDescs", "[" + (item.description || "") + "]");
        // if coords is empty, only commas, or falsy → set []
        if (!coords || coords.replace(/,/g, "").trim() === "") {
          formData.append("tmlPhotoLoc", "[]");
        } else {
          formData.append("tmlPhotoLoc", `[${coords}]`);
        }
        formData.append("locName", "[" + (item.location || "") + "]");
        formData.append("imgs", item.imageFile);

        await Api.uploadImage(tenantId, formData);
      }

      setPhotosList([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      onUploadSuccess && onUploadSuccess();
      onCancelDialog && onCancelDialog();
    } catch (e) {
      console.error(e);
    } finally {
      setIsUploading(false);
    }
  };

  const onAddPhotoClick = async (event) => {
    if (isUploading) return;
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) {
      console.log("No file selected");
      return;
    }

    const compressedPhotos = await Promise.all(
      selectedFiles.map(async (file, index) => {
        const compressedFile = await compressFile(file);
        return {
          id: Date.now() + index + Math.random(),
          description: "",
          imageFile: compressedFile,
          location: "",
          coordinates: "",
        };
      })
    );

    setPhotosList((prevList) => [...prevList, ...compressedPhotos]);
    if (event.target) {
      event.target.value = null;
    }
  };

  const handleClick = (photoId) => {
    if (isUploading) return;
    setOpen(true);
    setActivePhotoId(photoId);
  };

  const onLocationSubmit = (id) => {
    const list = photosList.map((item) =>
      item.id === id
        ? {
            ...item,
            location: isLocationSelect,
            coordinates: `${isLat},${isLng}`,
          }
        : item
    );
    // Update the state with the new list
    setPhotosList(list);
  };

  const handleCloseDialog = () => {
    if (isUploading) return;
    setPhotosList([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    onCancelDialog && onCancelDialog();
  };

  return (
    <section
      className="uploadPhotoTimelineDialog popup-background active"
      style={{ zIndex: zIndex, display: showDialog ? "flex" : "none" }}
    >
      <div className="photo-dialog">
        <div className="photo-dialog-header">
          <p>Post Photo to Timeline</p>
          <div className="close-icon" onClick={handleCloseDialog}>
            <img src={closebutton} alt="icon" />
          </div>
        </div>

        <div className="photo-list-container">
          {photosList.length > 0 ? (
            photosList.map((e) => (
              <PostPhotoItem
                key={`key-${e?.id}`}
                id={e.id}
                description={e.description}
                imageFile={e.imageFile}
                location={e.location}
                removeImageClick={removeImageClick}
                onDescriptionChange={onDescriptionChange}
                handleClick={() => handleClick(e.id)}
                isLocationSelect={isLocationSelect}
                setIsLocationSelect={setIsLocationSelect}
                setLng={setLng}
                setLat={setLat}
                isLat={isLat}
                isLng={isLng}
                onLocationSubmit={onLocationSubmit}
                setOpen={setOpen}
                open={open && activePhotoId === e.id}
              />
            ))
          ) : (
            <div className="no-data-container">
              <p>Please Select Photos.</p>
            </div>
          )}
        </div>

        <div
          className="uploadPhotoBottom save-button-container"
          style={{ width: "100%", display: "flex" }}
        >
          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <label
              htmlFor="photoUpload"
              className="addPhotoButton"
              style={{
                opacity: isUploading ? 0.6 : 1,
                pointerEvents: isUploading ? "none" : "auto",
              }}
            >
              <img src={Add} alt="" /> <span>Add Photo</span>
            </label>
            <input
              id="photoUpload"
              ref={fileInputRef}
              type="file"
              accept="image/*" // Limit to image files
              multiple
              onChange={onAddPhotoClick}
              disabled={isUploading}
              style={{ display: "none" }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <button
              type="button"
              className="post-button"
              onClick={onPostClick}
              disabled={isUploading || photosList.length === 0}
              style={{
                opacity: isUploading || photosList.length === 0 ? 0.6 : 1,
                cursor: isUploading || photosList.length === 0 ? "not-allowed" : "pointer",
              }}
            >
              {isUploading ? "Posting..." : "Post"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
